import { Container, PortalLayout, Stack, Typography } from "../../design-system";
import { renewalStatusContent } from "./content";

/**
 * /renewal-status (AC-3, AC-28, ADR-20261008-25dm). Reached when a redeem
 * confirm's outcome is `read_only` -- a submitted renewal whose working
 * copy has been purged. Rendered in `PortalLayout` with the help line
 * (ADR-20261008-hsvr amendment 2026-10-11). Contains no input, select or
 * textarea element and no submit action, and no action of any kind: this
 * is a dead-end status view, not a step the customer continues from.
 */
export function RenewalStatusPage() {
  return (
    <PortalLayout helpLine={renewalStatusContent.helpLine}>
      <Container>
        <Stack gap="lg">
          <Typography variant="heading1" as="h1">
            {renewalStatusContent.heading}
          </Typography>
          <Typography variant="body">{renewalStatusContent.body}</Typography>
        </Stack>
      </Container>
    </PortalLayout>
  );
}
